import Serializer from 'umg-ember-backend/serializers/application';

export default class TeaserSerializer extends Serializer {
  attrs = {
    link: 'linkId',
    category: 'categoryId1',
    asset: 'assetId',
    backgroundImage: 'backgroundImageId',
  };
}
